<div [class.fullscreen]="fullScreenLeftBox">
    <div class="ageing-hierarchy-table">
        <div class="left-box-filter ltms-widget-title">
            {{ leftBoxHeading }}
            <!-- <app-ltms-custom-dropdown [options]="viewByDropDownOptions"></app-ltms-custom-dropdown> -->
            <div class="other-filter">
                <div class="filter-text">View by</div>
                <div class="drop-down-filter">
                    <!-- <app-ltms-dropdown [config]="dropdown" [elementid]="dropdown.elementid"
                        (onChange)="onFilterChange($event)"></app-ltms-dropdown> -->
                    <app-score-dropdown-menu [config]="viewTypeDropdown.config"
                        [selectedOption]="viewTypeDropdown['selectedOption']" [options]="viewTypeDropdown.options"
                        (selectedOptionChange)="onFilterChange($event)"></app-score-dropdown-menu>
                    <div class="action-ageing-tools">
                        <!-- <app-ltms-widget-tools [config]='widgetConfig' [elementId]="widgetConfig.elementId"
                (onViewChange)="onViewChange($event)"></app-ltms-widget-tools> -->
                        <app-score-widget [config]="scoreWidget('drilldown')" (onDownloadClick)="onDownload()"
                            (onFullscreenClick)="onFullscreenLeftBox($event, 'drillDownTable')"></app-score-widget>
                    </div>
                </div>
            </div>
        </div>
        <div class="left-box-discription ltms-description">
            {{ leftBoxDiscription }}
        </div>
        <div *ngIf="isDataAvailable && isDataLoaded">
            <div class="left-box-table-upper">
                <!-- <app-ltms-drilldown-table [data]="overallTableData" [tableId]="overAllTableId"
            [staticId]="overallStaticId"></app-ltms-drilldown-table> -->
                <app-score-table [tableColumns]="distributionTable.tableHeader" (onTextClickCall)="resetHierarchData()"
                    [tableData]="distributionTable.tableRow"></app-score-table>
            </div>
            <div class="left-box-table">
                <!-- <app-ltms-drilldown-table [data]="drillDownTableData" [tableId]="childTableId" [staticId]="childStaticId"
            (onHirarchyChange)="onDrillDown($event)"></app-ltms-drilldown-table> -->
                <app-score-table [tableColumns]="comapreWithTable.tableHeader" (onDrillDownClick)="onDrillDown($event, 'drilldown')"
                    (onTextClickCall)="onDrillDown($event, 'selectRow')" [tableData]="comapreWithTable.tableRow"></app-score-table>
            </div>
        </div>
        <div *ngIf="!isDataAvailable && isDataLoaded">
            <app-ltms-error [code]="errorCode"></app-ltms-error>
        </div>
        <div class="data-details-loader" *ngIf="isDataLoaded == false">
            <app-ltms-loader></app-ltms-loader>
        </div>
    </div>
</div>